<template>
	<el-dialog :visible.sync="dialogVisible"
		:title="dialogTitle"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:append-to-body="true"
		@closed="resetForm"
		top="0px"
		width="500px">

		<el-form :model="form" label-width="120px" label-suffix="：">
			<div v-if="dialogType==='mobile'">
				<el-form-item label="旧手机号码" v-if="loginInfo.mobile">
					<el-input v-model="form.oldMobile" :placeholder="'输入原完整号码' + loginInfo.mobile"></el-input>
				</el-form-item>
				<el-form-item label="新手机号码">
					<el-input v-model="form.newMobile" placeholder="输入新号码"></el-input>
				</el-form-item>
				<el-form-item label="图形验证码" v-if="form.captcha.show">
					<el-input v-model="form.captcha.code" class="short-input" placeholder="图形验证码"></el-input>
					<img class="form-captcha" :src="form.captcha.src" alt="点击刷新" title="验证码" @click="initCaptcha">
				</el-form-item>
				<el-form-item label="短信验证码">
					<el-input v-model="form.smsCode" class="short-input" placeholder="短信验证码"></el-input>
					<el-button class="code-btn" type="primary" plain v-if="waitSecond<=0" @click="sendCode">发送短信验证码</el-button>
					<el-button class="code-btn" type="primary" plain disabled v-else>{{waitSecond}}s后重新获取</el-button>
				</el-form-item>
			</div>

			<div v-if="dialogType==='email'">
				<el-form-item label="旧邮箱" v-if="loginInfo.email">
					<el-input v-model="form.oldEmail" :placeholder="'输入原完整邮箱' + loginInfo.email"></el-input>
				</el-form-item>
				<el-form-item label="新邮箱">
					<el-input v-model="form.newEmail" placeholder="输入新邮箱"></el-input>
				</el-form-item>
				<el-form-item label="图形验证码" v-if="form.captcha.show">
					<el-input v-model="form.captcha.code" class="short-input" placeholder="图形验证码"></el-input>
					<img class="form-captcha" :src="form.captcha.src" alt="点击刷新" title="验证码" @click="initCaptcha">
				</el-form-item>
				<el-form-item label="邮箱验证码">
					<el-input v-model="form.emailCode" class="short-input" placeholder="邮箱验证码"></el-input>
					<el-button class="code-btn" type="primary" plain v-if="waitSecond<=0" @click="sendCode">发送邮箱验证码</el-button>
					<el-button class="code-btn" type="primary" plain disabled v-else>{{waitSecond}}s后重新获取</el-button>
				</el-form-item>
			</div>

			<div class="form-btn" style="text-align: right">
				<el-button type="primary" @click="saveUpdate" :loading="form.loading">保存</el-button>
				<el-button @click="dialogVisible=false">取消</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>

<script>
  import base from '@/api/common';
  import qs from 'qs';

  export default {
    name: "ChangeLoginInfo",
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '',
        dialogType: '',
        loginInfo: {
          account: '',
          mobile: '',
          email: '',
        },
        form: {
          oldMobile: '',
          newMobile: '',
          smsCode: '',

          oldEmail: '',
          newEmail: '',
          emailCode: '',

          captcha: {
            show: false,
            token: '',
            src: '',
            code: ''
          },

          loading: false,
        },
        waitTimer: 0,
        waitInitSecond: 10,
        waitSecond: 0,
      }
    },
    methods: {
      resetForm() {
        this.dialogTitle = '';
        this.dialogType = '';

        this.loginInfo.account = '';
        this.loginInfo.mobile = '';
        this.loginInfo.email = '';

        this.form.oldMobile = '';
        this.form.newMobile = '';
        this.form.oldEmail = '';
        this.form.newEmail = '';
      },
      initCaptcha() {
        this.form.captcha.token = '';
        this.form.captcha.src = '';
        this.form.captcha.code = '';
        this.$ajax.post(base.api.captcha).then(res => {
          if (res.data.status === 'success') {
            this.form.captcha.src = res.data.data;
            this.form.captcha.token = res.data.token;
            return;
          }
          this.$message.error('图形验证码加载失败');
        }).catch(err => {
          this.$message.error('图形验证码加载失败');
        });
      },
      sendCode() {

        let url;
        if (this.dialogType === 'mobile') {
          if (!base.reg.mobile.test(this.form.newMobile)) {
            this.$message.warning('新手机号码无效');
            return;
          }
          url = base.api.sms.updateMobile;
        } else if (this.dialogType === 'email') {
          if (!base.reg.email.test(this.form.newEmail)) {
            this.$message.warning('新邮箱无效');
            return;
          }
          url = base.api.email.updateEmail;
        } else {
          return;
        }

        let that = this;
        if ($.trim(that.form.captcha.code).length === 0) {
          that.$message.warning('请输入图形验证码');
          if (!that.form.captcha.show) {
            that.form.captcha.show = true;
            that.initCaptcha();
          }
          return;
        } else if ($.trim(that.form.captcha.code).length !== 4) {
          that.form.captcha.show = true;
          that.initCaptcha();
          that.$message.warning('图形验证码错误');
          return;
        }

        that.waitSecond = that.waitInitSecond;
        clearInterval(that.waitTimer);
        that.waitTimer = setInterval(() => {
          that.waitSecond--;
          if (that.waitSecond < 0) {
            clearInterval(that.waitTimer);
          }
        }, 1000);

        //发送
        let data = {
          mobile: that.form.newMobile,
          email: that.form.newEmail,
          token: that.form.captcha.token,
          code: that.form.captcha.code
        };
        that.$ajax.post(url, qs.stringify(data)).then(res => {
          if (res.data.status === 'success') {
            that.$message.success('发送成功');
            that.form.captcha.show = false;
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('发送失败')
        });
      },
      saveUpdate() {
        let url, data, that = this;
        if (this.dialogType === 'mobile') {
          if (this.loginInfo.mobile && !base.reg.mobile.test(this.form.oldMobile)) {
            this.$message.warning('旧手机号码无效');
            return;
          }
          if (!base.reg.mobile.test(this.form.newMobile)) {
            this.$message.warning('新手机号码无效');
            return;
          }
          if ($.trim(that.form.smsCode).length !== 6) {
            that.$message.warning('短信验证码不正确');
            return;
          }
          url = base.api.auth.updateMobile;
          data = {
            oldMobile: that.form.oldMobile,
            mobile: that.form.newMobile,
            smsCode: that.form.smsCode,
          };
        } else if (this.dialogType === 'email') {
          if (this.loginInfo.email && !base.reg.mobile.test(this.form.oldEmail)) {
            this.$message.warning('旧邮箱无效');
            return;
          }
          if (!base.reg.email.test(this.form.newEmail)) {
            this.$message.warning('新邮箱无效');
            return;
          }
          if ($.trim(that.form.emailCode).length !== 6) {
            that.$message.warning('邮箱验证码不正确');
            return;
          }
          url = base.api.auth.updateEmail;
          data = {
            oldEmail: that.form.oldEmail,
            email: that.form.newEmail,
            emailCode: that.form.emailCode,
          };
        } else {
          return;
        }
        that.form.loading = true;
        that.$ajax.post(url, qs.stringify(data)).then(res => {
          if (res.data.status === 'success') {
            that.$message.success('修改成功');
            setTimeout(() => {
              localStorage.clear();
              that.$router.push({path: '/login'});
            }, 1500)
          } else {
            that.form.loading = false;
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          that.form.loading = false;
          that.$message.error('修改失败');
        });
      }
    }
  }
</script>

<style type="scss" scoped>

	.code-btn {
		width: 140px;
		margin-left: 20px;
	}

	.short-input {
		width: 180px;
	}

</style>
<style type="css" scoped>
	.form-btn {
		margin-top: 60px;
	}

	.form-btn button {
		padding: 0 20px;
		height: 30px;
		line-height: 30px;
	}

	img.form-captcha {
		height: 40px;
		vertical-align: bottom;
		margin-left: 20px;
	}
</style>
